import React, { useState, useEffect } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { API_BASE_URL, BASE_URL } from '../config/config';
const HeroBanner = () => {
  const [banners, setBanners] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loading, setLoading] = useState(true);
 

  useEffect(() => {
    fetchBanners();
  }, []);

  useEffect(() => {
    if (banners.length > 1) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % banners.length);
      }, 5000); // Auto-slide every 5 seconds

      return () => clearInterval(interval);
    }
  }, [banners]);

  const fetchBanners = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/banners`);
      const data = await response.json();
      
      if (data.success && data.data && data.data.length > 0) {
        setBanners(data.data);
      }
    } catch (error) {
      console.error('Error fetching banners:', error);
    } finally {
      setLoading(false);
    }
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % banners.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + banners.length) % banners.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  if (loading) {
    return (
      <div className="relative h-64 md:h-96 lg:h-[500px] bg-gradient-to-r from-primary-500 to-purple-600 animate-pulse">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-white"></div>
        </div>
      </div>
    );
  }

  if (banners.length === 0) {
    return (
      <div className="relative h-64 md:h-96 lg:h-[500px] bg-gradient-to-r from-primary-500 via-purple-600 to-pink-600 overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative h-full flex items-center justify-center text-white text-center px-4">
          <div className="max-w-4xl">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4 animate-fade-in">
              Welcome to Raj Economics (RECC)
            </h1>
            <p className="text-xl md:text-2xl lg:text-3xl mb-8 animate-fade-in-delay">
              Your Gateway to Success in Competitive Exams
            </p>
            <a
              href="/courses"
              className="inline-block bg-white text-primary-600 px-8 py-3 rounded-lg font-semibold hover:shadow-xl transition-all transform hover:scale-105"
            >
              Explore Courses
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative h-48 sm:h-64 md:h-80 lg:h-96 xl:h-[500px] overflow-hidden bg-gray-900">
      {/* Banner Images */}
      {banners.map((banner, index) => (
        <div
          key={banner.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={`${BASE_URL}/public/uploads/gallery/media/${banner.image}`}
            alt={`Banner ${index + 1}`}
            className="w-full h-full object-cover sm:object-cover object-center"
            style={{
              objectPosition: 'center center'
            }}
            onError={(e) => {
              e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="1920" height="600"%3E%3Crect fill="%236366f1" width="1920" height="600"/%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" fill="white" font-size="48"%3ERaj Economics%3C/text%3E%3C/svg%3E';
            }}
          />
          {/* Dark Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
        </div>
      ))}

      {/* Navigation Arrows */}
      {banners.length > 1 && (
        <>
          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-2 md:p-3 rounded-full shadow-lg transition-all hover:scale-110 z-10"
            aria-label="Previous slide"
          >
            <FiChevronLeft className="w-5 h-5 md:w-6 md:h-6" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 p-2 md:p-3 rounded-full shadow-lg transition-all hover:scale-110 z-10"
            aria-label="Next slide"
          >
            <FiChevronRight className="w-5 h-5 md:w-6 md:h-6" />
          </button>
        </>
      )}

      {/* Dots Indicator */}
      {banners.length > 1 && (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
          {banners.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all ${
                index === currentSlide 
                  ? 'bg-white w-8 md:w-10' 
                  : 'bg-white/50 hover:bg-white/75'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      )}

      {/* Content Overlay (Optional - can be customized) */}
      <div className="absolute inset-0 flex items-center justify-center text-white text-center px-4 pointer-events-none">
        <div className="max-w-4xl">
          {/* You can add overlay text here if needed */}
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;

